module.exports = __webpack_public_path__ + "static/media/ts12sj.b3082ccc.png";